type OfficeEditActor = {
  isSuperAdmin: boolean
  isCompanyAdmin: boolean
  isCompanyGroupAdmin: boolean
  isOperator: boolean
}

export function canEditCrewDataAtOfficeReview(
  actor: OfficeEditActor,
  hasUpdatePermission: boolean,
  hasApprovePermission: boolean
): boolean {
  if (actor.isSuperAdmin) return true
  return !actor.isOperator && (actor.isCompanyAdmin || actor.isCompanyGroupAdmin) &&
    hasUpdatePermission && hasApprovePermission
}
